"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var EmptyComponent = function EmptyComponent(props) {
  var isSearch = props.isSearch,
      emptyTipDom = props.emptyTipDom,
      emptyDataLabel = props.emptyDataLabel;

  if (!isSearch) {
    return _react["default"].createElement("div", {
      className: "spaui-columns-main empty"
    }, _react["default"].createElement("i", {
      className: "icon spaui-columns-icon-empty"
    }), emptyTipDom);
  } else {
    return _react["default"].createElement("div", {
      className: "spaui-columns-main empty no-search-data"
    }, _react["default"].createElement("i", {
      className: "icon spaui-columns-icon-empty"
    }), _react["default"].createElement("p", null, emptyDataLabel));
  }
};

var _default = EmptyComponent;
exports["default"] = _default;